import { Component, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthService } from '../../services/auth.service';
import { MatDatepicker, MatDateRangePicker } from '@angular/material/datepicker';
import * as moment from 'moment';
import { MatLegacySnackBar as MatSnackBar } from '@angular/material/legacy-snack-bar';
import { Moment } from 'moment';
import { LobbyPage, EstimateTab, estimatesTabs } from '../../models/navigation.model';
import { ModalBehavior, ModalsService } from 'projects/common/src/lib/services/modals.service';
import { RequestInvitationModal } from '../../modals/request-invitation/request-invitation.component';
import { EstimatesService, TiledEstimate } from "../../services/estimates.service";
import { NavigationService } from '../../services/navigation.service';
import { DateFilter } from '../../models/date-filter.model';
import { LobbyService } from '../../services/lobby.service';
import { EditClientComponent } from "../../modals/edit-client/edit-client.component";
import { Client } from "projects/common/src/lib/models";
import { ViewAsService } from '../../services/view-as.service';

@Component({
  selector: 'app-estimates',
  templateUrl: './estimates.component.html',
  styleUrls: ['./estimates.component.scss']
})
export class EstimatesComponent {

  tabs = Array.from(estimatesTabs);
  showCreateButton = true;

  user$ = this.authService.user$;

  disableFilter = false;

  loadingEstimates = false;

  @ViewChild('heightTester') heightTester: any;
  @ViewChild('picker') datePicker!: MatDateRangePicker<any>;

  datePickerOpen = false;

  page$ = this.navigationService.page$;
  tab$ = this.navigationService.tab$;

  actualSelectedDate!: [Date, Date] | null;

  // estimates$ = this.tab$.pipe(
  //   switchMap(tab => {
  //     switch (tab) {
  //       case 'Won':
  //         return this.estimatesService.wonEstimates$.pipe(tiledEstimatesForType(tab));
  //       case 'Pending':
  //         return this.estimatesService.pendingEstimates$.pipe(tiledEstimatesForType(tab));
  //       case 'Declined':
  //         return this.estimatesService.declinedEstimates$.pipe(tiledEstimatesForType(tab));
  //       case 'Canceled':
  //         return this.estimatesService.canceledEstimates$.pipe(tiledEstimatesForType(tab));
  //       case 'Drafts':
  //         return this.estimatesService.draftsEstimates$.pipe(tiledEstimatesForType(tab));
  //     }
  //   }),
  //   // separateItemsByDate(estimate => dateString(estimate.createdAt))
  // );

  dateFilter$ = this.lobbyService.selectedDateRangeForEvent$;

  constructor(
    private authService: AuthService,
    private navigationService: NavigationService<LobbyPage, EstimateTab>,
    private router: Router,
    private route: ActivatedRoute,
    public snackbar: MatSnackBar,
    public modalsService: ModalsService,
    private estimatesService: EstimatesService,
    private lobbyService: LobbyService,
    public viewAsService: ViewAsService
  ) {}

  onTabSelected(tab: string) {
    const useTab = tab === 'From Video' ? 'from-video' : tab.toLowerCase();
    this.router.navigate([useTab], { relativeTo: this.route });
  }

  datesFilter(d: Moment | null) {
    if(!d) {
      return false;
    }
    const now = moment().startOf('day');
    const date = d.startOf('day');
    return date.diff(now) <= 0;
  }

  keys(obj: any) {
    return Object.keys(obj);
  }

  searchResultsForTab(searchResults: any, type: string) {
    return searchResults[type];
  }

  openCreateRequestDialog() {
    this.modalsService.open(RequestInvitationModal, {
      behavior: ModalBehavior.Auto,
      breakpoint: RequestInvitationModal.BREAKPOINT,
      disableClose: true,
      data: {}
    });
  }

  async createEstimate(): Promise<void> {
    await this.modalsService.open(EditClientComponent, {
      behavior: ModalBehavior.Auto,
      disableClose: true,
      data: {
        client: {} as Client,
        estimatesService: this.estimatesService,
        creation: true,
        which: 'Estimate'
      }
    });
  }

  openPicker(picker: MatDatepicker<any>) {
    if(!this.disableFilter)
      picker.open();
  }

  objectLength(obj: any) {
    return Object.keys(obj).length;
  }

  selectedRangeChange(event: [Date, Date] | null) {
    this.actualSelectedDate = event;
  }

  datePickerClose(status: boolean) {
    if (!status)
      this.lobbyService.setSelectedDateRange(this.actualSelectedDate ? DateFilter.from(this.actualSelectedDate) : null);
  }
}
